let sharedCanvas: HTMLCanvasElement | null = null;
let sharedContext: CanvasRenderingContext2D | null = null;

/**
 * Measures the rendered pixel width of a string for a given CSS font shorthand,
 * using a single cached canvas 2D context (canvas text measurement is not
 * affected by layout, so it can measure text that isn't in the DOM).
 */
export const measureTextWidth = (text: string, font: string): number => {
  if (!sharedContext) {
    sharedCanvas = document.createElement('canvas');
    sharedContext = sharedCanvas.getContext('2d');
  }

  if (!sharedContext) return 0;

  sharedContext.font = font;
  return sharedContext.measureText(text).width;
};
